var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"title":_vm.value}},[(_vm.option)?_c('el-tag',{attrs:{"effect":"dark","size":"mini","type":_vm.option.color}},[_vm._v(_vm._s(_vm.option.en||_vm.option.zh||_vm.option.value||_vm.value))]):_c('span',[_vm._v(_vm._s(_vm.value))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }